import React from 'react';
import { heroData } from '../data/mock';

const Hero = () => {
  const handleScroll = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };

  return (
    <section className="editorial-hero">
      <div className="container">
        <div className="editorial-hero-content">
          <h1 className="editorial-hero-title">
            {heroData.title}
          </h1>
          <p className="editorial-hero-subtitle">
            {heroData.subtitle}
          </p>
          <button className="editorial-scroll-indicator" onClick={handleScroll}>
            {heroData.scrollText}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
